import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'

const getLeagueNotes = async (params: {
  belongsToIds: string
  page: number
  limit: number
}) => {
  const response = await axiosGet('v1/notes/get-notes', params)
  return response.data
}

export const useGetLeagueNotes = (
  leagueEventId: string,
  page: number,
  limit = 10,
) => {
  return useQuery(
    ['league-notes', leagueEventId, page],
    () => getLeagueNotes({ belongsToIds: leagueEventId, page, limit }),
    { enabled: !!leagueEventId },
  )
}

const addLeagueNote = async ({
  adminId,
  payload,
}: {
  adminId: string
  payload: any
}) => {
  const response = await axiosPost(
    payload,
    `v1/notes/add-note/by-admin/${adminId}`,
  )
  return response.data
}

export const useAddLeagueNote = () => {
  const queryClient = useQueryClient()
  return useMutation(addLeagueNote, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(['league-notes', variables.payload.leagueId])
    },
  })
}

const editLeagueNote = async ({
  noteId,
  payload,
}: {
  noteId: string
  payload: { description: string; type?: string; method?: string }
}) => {
  const response = await axiosPatch(payload, `v1/notes/edit-note/${noteId}`)
  return response.data
}

export const useEditLeagueNote = () => {
  const queryClient = useQueryClient()
  return useMutation(editLeagueNote, {
    onSuccess: () => {
      queryClient.invalidateQueries(['league-notes'])
    },
  })
}

const deleteLeagueNote = async (noteId: string) => {
  const response = await axiosDelete(`v1/notes/${noteId}`)
  return response.data
}

export const useDeleteLeagueNote = (leagueEventId: string) => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeagueNote, {
    onSuccess: () => {
      queryClient.invalidateQueries(['league-notes', leagueEventId])
    },
  })
}
